// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from "./utility/ProtectedRoute";

// HR
import LoginPage from './views/LoginPage';
import Dashboard from './views/Dashboard';
import HRForm from './views/add_staff';
import HRFormDashboard from './views/test'
import PhoneChecker from './views/PhoneChecker'
import Onboard from './views/onboard'
import ProfileCheckerPhone from './views/profileCheckerPhone'
import Staff_Profile from './views/ProfileChecker'
import StaffProfileView from './views/hr_staff/StaffProfileView'
import Dept from './views/dept'
import PassChange from './views/passwordChange'
import PassChange2 from './views/passwordChange2'
import Report from './views/report'
import SetSalary from './views/set_salary'
import HrLeaveDashboard from './views/HrLeaveDashboard'
import StaffAppraisals from './views/StaffAppraisals'
import QuarterlyReviews from './views/QuarterlyReviews'
import SalaryDeductions from './views/SalaryDeductions'
import SalaryDeductionApprovals from './views/SalaryDeductionApprovals'
import HrReportsDashboard from './views/HrReportsDashboard'
import TaskManagement from './views/TaskManagement'
import SalaryProrate from './views/SalaryProrate'
import StaffSalaryHistory from './views/StaffSalaryHistory'



// Ordinary Staff
import Dashboard_staff from './views/hr_staff/Dashboard';
import LeaveCalendar from './views/hr_staff/LeaveCalendar';
import HRForm2 from './views/hr_staff/add_staff';
import Onboard2 from './views/hr_staff/onboard'
import TaskManagementStaff from './views/hr_staff/TaskManagementStaff'



// store keeper
import LeaveCalendar_Storekeeper from './views/store_keeper/LeaveCalendar_Storekeeper';
import Dashboard_store_keeper from './views/store_keeper/dashboard_store_keeper';
import Onboard_storekeeper from './views/hr_staff/Onboard_Storekeeper'
import PasswordChange_storekeeper from './views/passwordChange_storekeeper'
import InventoryManagement from './views/store_keeper/InventoryManagement'
import AuditorApproval from './views/store_keeper/AuditorApproval'
import ItemNamesManagement from './views/store_keeper/ItemNamesManagement'
import RequisitionManagement from './views/store_keeper/RequisitionManagement'
import StoreKeeperViewRequisition from './views/store_keeper/StoreKeeperViewRequisition'
import PurchaseRequests from './views/store_keeper/PurchaseRequests'



// Accountant Area
import Dashboard_accountant from './views/accountant/Dashboard_accountant'
import LeaveCalendar_accountant from './views/accountant/LeaveCalendar_accountant'
import AccountantSalaryDashboard from './views/accountant/AccountantSalaryDashboard'
import AccountantInventoryDashboard from './views/accountant/AccountantInventoryDashboard'
import PayrollGeneratorAccount from './views/accountant/PayrollGeneratorAccount'
import PurshaseOrdeAccountApproval from './views/accountant/PurshaseOrdeAccountApproval'


// Auditor
import Dashboard_auditor from './views/auditor/Dashboard_auditor'
import Password_Change_auditor from './views/passwordChange_auditor'
import Onboard_auditor from './views/auditor/Onboard_auditor'
import LeaveCalendar_auditor from './views/auditor/LeaveCalendar_auditor'
import AuditorSalaryDashboard from './views/auditor/AuditorSalaryDashboard'
import AuditorDeductionDashboard from './views/auditor/AuditorDeductionDashboard'
import PayrollGeneratorAuditor from './views/auditor/PayrollGeneratorAuditor'
import AuditorProfileCheckerPhone from './views/auditor/AuditorProfileCheckerPhone'
import AuditorProfileChecker from './views/auditor/AuditorProfileChecker'
import AuditorRemark from './views/auditor/AuditorRemark'



import Dashboard_HOD_requisition_staff from './views/HOD_requisition_staff/Dashboard_HOD_requisition_staff'
import LeaveCalendar_HOD_requisition_staff from './views/HOD_requisition_staff/LeaveCalendar_HOD_requisition_staff'

import PasswordChangeRequisition from './views/passwordChange_requisition'



import Dashboard_Hod from './views/HOD/Dashboard_hod'
import LeaveCalendar_hod from './views/HOD/LeaveCalendar_hod'
import HODRequisitionApproval from './views/HOD/HODRequisitionApproval'
import PasswordChange_hod from './views/passwordChange_hod'
import TaskManagementHOD from './views/HOD/TaskManagementHOD'

//GM
import Dashboard_gm from './views/GM/Dashboard_gm'
import GMRequisitionApproval from './views/GM/GMRequisitionApproval'
import GMInventoryDashboard from './views/GM/GMInventoryDashboard'
import PasswordChangeForm from './views/passwordChange_GM'
import LeaveCalendar_gm from './views/GM/LeaveCalendar_gm'
import SalaryApprovals from './views/GM/SalaryApprovals'
import GmDeductionDashboard from './views/GM/GmDeductionDashboard'
import PayrollGenerator from './views/GM/PayrollGenerator'
import PurshaseOrdeGMApproval from './views/GM/PurshaseOrdeGMApproval'
import StaffDirectory from './views/GM/StaffDirectory'
import TaskManagementDashboard from './views/GM/TaskManagementDashboard'



import EmailComposer from './views/email/sendEmail'
import Send_EmailStaff from './views/email/sendEmailstaff'




function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr']}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Dashboard_store_keeper"
          element={
            <ProtectedRoute allowedRoles={['admin', 'store_keeper']}>
              <Dashboard_store_keeper />
            </ProtectedRoute>
          }
        />

         
       
          <Route
          path="/add_staff"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr']}>
              <HRForm />
            </ProtectedRoute>
          }
        />

             <Route
          path="/PhoneChecker"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr']}>
              <PhoneChecker />
            </ProtectedRoute>
          }
        />

  <Route
          path="/onboard"
          element={
            <ProtectedRoute allowedRoles={['admin', 'hr']}>
              <Onboard />
            </ProtectedRoute>
          }
        />

 <Route
          path="/Onboard_storekeeper"
          element={
            <ProtectedRoute allowedRoles={['admin', 'store_keeper']}>
              <Onboard_storekeeper />
            </ProtectedRoute>
          }
        />


 <Route
          path="/ProfileCheckerPhone"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <ProfileCheckerPhone />
            </ProtectedRoute>
          }
        />

<Route
          path="/HrLeaveDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <HrLeaveDashboard />
            </ProtectedRoute>
          }
        />

<Route
          path="/TaskManagement"
          element={
            <ProtectedRoute allowedRoles={['admin','hr']}>
              <TaskManagement />
            </ProtectedRoute>
          }
        />


<Route
          path="/LeaveCalendar"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <LeaveCalendar />
            </ProtectedRoute>
          }
        />

<Route
          path="/LeaveCalendar_Storekeeper"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <LeaveCalendar_Storekeeper />
            </ProtectedRoute>
          }
        />

         <Route
          path="/Staff_Profile"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <Staff_Profile />
            </ProtectedRoute>
          }
        />
 <Route
          path="/dept"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <Dept />
            </ProtectedRoute>
          }
        />
<Route
          path="/PassChange"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <PassChange />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Report"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <Report />
            </ProtectedRoute>
          }
        />

  <Route
          path="/StaffAppraisals"
          element={
            <ProtectedRoute allowedRoles={['admin','hr']}>
              <StaffAppraisals />
            </ProtectedRoute>
          }
        />

 <Route
          path="/QuarterlyReviews"
          element={
            <ProtectedRoute allowedRoles={['admin','hr']}>
              <QuarterlyReviews />
            </ProtectedRoute>
          }
        />

<Route
          path="/SalaryDeductions"
          element={
            <ProtectedRoute allowedRoles={['admin','hr']}>
              <SalaryDeductions />
            </ProtectedRoute>
          }
        />


<Route
          path="/HrReportsDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','hr']}>
              <HrReportsDashboard />
            </ProtectedRoute>
          }
        />



<Route
          path="/SalaryDeductionApprovals"
          element={
            <ProtectedRoute allowedRoles={['admin','account']}>
              <SalaryDeductionApprovals />
            </ProtectedRoute>
          }
        />

         <Route
          path="/set_salary"
          element={
            <ProtectedRoute allowedRoles={['admin','hr', 'store_keeper']}>
              <SetSalary />
            </ProtectedRoute>
          }
        />
        
 <Route
          path="/Send_Email"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <EmailComposer />
            </ProtectedRoute>
          }
        />
        
         <Route
          path="/Send_EmailStaff"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <Send_EmailStaff />
            </ProtectedRoute>
          }
        />


         <Route
          path="/StaffProfileView"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper','hod','requisition_staff','gm','auditor']}>
              <StaffProfileView />
            </ProtectedRoute>
          }
        />
{/* hr_Staff Area*/}


 <Route
          path="/dashboard_staff"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <Dashboard_staff />
            </ProtectedRoute>
          }
        />
<Route
          path="/onboard_staff"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <Onboard2 />
            </ProtectedRoute>
          }
        />

<Route
          path="/TaskManagementStaff"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <TaskManagementStaff />
            </ProtectedRoute>
          }
        />

         <Route
          path="/add_staff2"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <HRForm2 />
            </ProtectedRoute>
          }
        />


  <Route
          path="/SalaryProrate"
          element={
            <ProtectedRoute allowedRoles={['admin','hr']}>
              <SalaryProrate />
            </ProtectedRoute>
          }
        />

<Route
          path="/StaffSalaryHistory"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <StaffSalaryHistory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/PassChange2"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <PassChange2 />
            </ProtectedRoute>
          }
        />


  <Route
          path="/PasswordChange_storekeeper"
          element={
            <ProtectedRoute allowedRoles={['admin','hr','hr_staff', 'store_keeper']}>
              <PasswordChange_storekeeper />
            </ProtectedRoute>
          }
        />



{/* auditor Area*/}
 <Route
          path="/Dashboard_auditor"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <Dashboard_auditor />
            </ProtectedRoute>
          }
        />


<Route
          path="/Password_Change_auditor"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor','requisition_staff']}>
              <Password_Change_auditor />
            </ProtectedRoute>
          }
        />


        <Route
          path="/Onboard_auditor"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <Onboard_auditor />
            </ProtectedRoute>
          }
        />

  <Route
          path="/LeaveCalendar_auditor"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <LeaveCalendar_auditor />
            </ProtectedRoute>
          }
        />
        
 <Route
          path="/AuditorSalaryDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <AuditorSalaryDashboard />
            </ProtectedRoute>
          }
        />

 <Route
          path="/AuditorDeductionDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <AuditorDeductionDashboard />
            </ProtectedRoute>
          }
        />
        

<Route
          path="/PayrollGeneratorAuditor"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <PayrollGeneratorAuditor />
            </ProtectedRoute>
          }
        />
        
<Route
          path="/AuditorProfileCheckerPhone"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <AuditorProfileCheckerPhone />
            </ProtectedRoute>
          }
        />
        
<Route
          path="/AuditorRemark"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <AuditorRemark />
            </ProtectedRoute>
          }
        />
        

        <Route
          path="/AuditorProfileChecker"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <AuditorProfileChecker />
            </ProtectedRoute>
          }
        />
        

        <Route
          path="/AuditorApproval"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <AuditorApproval />
            </ProtectedRoute>
          }
        />





{/* accountant Area*/}
 <Route
          path="/Dashboard_accountant"
          element={
            <ProtectedRoute allowedRoles={['admin','account']}>
              <Dashboard_accountant />
            </ProtectedRoute>
          }
        />


<Route
          path="/LeaveCalendar_accountant"
          element={
            <ProtectedRoute allowedRoles={['admin','account']}>
              <LeaveCalendar_accountant />
            </ProtectedRoute>
          }
        />

<Route
          path="/AccountantSalaryDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','account']}>
              <AccountantSalaryDashboard />
            </ProtectedRoute>
          }
        />

<Route
          path="/AccountantInventoryDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','account']}>
              <AccountantInventoryDashboard />
            </ProtectedRoute>
          }
        />

<Route
          path="/PayrollGeneratorAccount"
          element={
            <ProtectedRoute allowedRoles={['admin','account']}>
              <PayrollGeneratorAccount />
            </ProtectedRoute>
          }
        />

<Route
          path="/PurshaseOrdeAccountApproval"
          element={
            <ProtectedRoute allowedRoles={['admin','account']}>
              <PurshaseOrdeAccountApproval />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Onboard_auditor"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <Onboard_auditor />
            </ProtectedRoute>
          }
        />

  <Route
          path="/LeaveCalendar_auditor"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <LeaveCalendar_auditor />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/AuditorApproval"
          element={
            <ProtectedRoute allowedRoles={['admin','auditor']}>
              <AuditorApproval />
            </ProtectedRoute>
          }
        />

        
 {/* inventory_Staff Area*/}
 
 <Route
          path="/Dashboard_store_keeper"
          element={
            <ProtectedRoute allowedRoles={['admin','hr', 'store_keeper']}>
              <Dashboard_store_keeper />
            </ProtectedRoute>
          }
        />

  
<Route
          path="/InventoryManagement"
          element={
            <ProtectedRoute allowedRoles={['admin','store_keeper']}>
              <InventoryManagement />
            </ProtectedRoute>
          }
        />

<Route
          path="/RequisitionManagement"
          element={
            <ProtectedRoute allowedRoles={['admin','requisition_staff','store_keeper']}>
              <RequisitionManagement />
            </ProtectedRoute>
          }
        />
<Route
          path="/StoreKeeperViewRequisition"
          element={
            <ProtectedRoute allowedRoles={['admin','store_keeper']}>
              <StoreKeeperViewRequisition />
            </ProtectedRoute>
          }
        />

<Route
          path="/PurchaseRequests"
          element={
            <ProtectedRoute allowedRoles={['admin','store_keeper']}>
              <PurchaseRequests />
            </ProtectedRoute>
          }
        />



<Route
          path="/ItemNamesManagement"
          element={
            <ProtectedRoute allowedRoles={['admin','store_keeper']}>
              <ItemNamesManagement />
            </ProtectedRoute>
          }
        />


 <Route
          path="/Dashboard_HOD_requisition_staff"
          element={
            <ProtectedRoute allowedRoles={['admin','requisition_staff']}>
              <Dashboard_HOD_requisition_staff />
            </ProtectedRoute>
          }
        />

        <Route
          path="/LeaveCalendar_HOD_requisition_staff"
          element={
            <ProtectedRoute allowedRoles={['admin','requisition_staff']}>
              <LeaveCalendar_HOD_requisition_staff />
            </ProtectedRoute>
          }
        />

 <Route
          path="/PasswordChangeRequisition"
          element={
            <ProtectedRoute allowedRoles={['admin','requisition_staff']}>
              <PasswordChangeRequisition />
            </ProtectedRoute>
          }
        />


  <Route
          path="/Dashboard_Hod"
          element={
            <ProtectedRoute allowedRoles={['admin','hod']}>
              <Dashboard_Hod />
            </ProtectedRoute>
          }
        />

 <Route
          path="/TaskManagementHOD"
          element={
            <ProtectedRoute allowedRoles={['admin','hod']}>
              <TaskManagementHOD />
            </ProtectedRoute>
          }
        />



<Route
          path="/LeaveCalendar_hod"
          element={
            <ProtectedRoute allowedRoles={['admin','hod']}>
              <LeaveCalendar_hod />
            </ProtectedRoute>
          }
        />


<Route
          path="/HODRequisitionApproval"
          element={
            <ProtectedRoute allowedRoles={['admin','hod']}>
              <HODRequisitionApproval />
            </ProtectedRoute>
          }
        />

<Route
          path="/PasswordChange_hod"
          element={
            <ProtectedRoute allowedRoles={['admin','hod']}>
              <PasswordChange_hod />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Dashboard_gm"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <Dashboard_gm />
            </ProtectedRoute>
          }
        />


  <Route
          path="/StaffDirectory"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <StaffDirectory />
            </ProtectedRoute>
          }
        />

 <Route
          path="/TaskManagementDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <TaskManagementDashboard />
            </ProtectedRoute>
          }
        />


  <Route
          path="/GMRequisitionApproval"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <GMRequisitionApproval />
            </ProtectedRoute>
          }
        />

<Route
          path="/GMInventoryDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <GMInventoryDashboard />
            </ProtectedRoute>
          }
        />



<Route
          path="/LeaveCalendar_gm"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <LeaveCalendar_gm />
            </ProtectedRoute>
          }
        />
<Route
          path="/SalaryApprovals"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <SalaryApprovals />
            </ProtectedRoute>
          }
        />

        <Route
          path="/GmDeductionDashboard"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <GmDeductionDashboard />
            </ProtectedRoute>
          }
        />

  <Route
          path="/PurshaseOrdeGMApproval"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <PurshaseOrdeGMApproval />
            </ProtectedRoute>
          }
        />

   <Route
          path="/PayrollGenerator"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <PayrollGenerator />
            </ProtectedRoute>
          }
        />


<Route
          path="/passwordChange_GM"
          element={
            <ProtectedRoute allowedRoles={['admin','gm']}>
              <PasswordChangeForm />
            </ProtectedRoute>
          }
        />

         <Route path="/testPage" element={<HRFormDashboard />} />
      </Routes>


    </Router>
  );
}

export default App;
